import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/index.js'
// import VueSwal from 'vue-swal'
import VueSweetalert2  from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import VTooltip from 'v-tooltip'
import ToggleButton from 'vue-js-toggle-button'

Vue.use(ToggleButton)
Vue.config.productionTip = false
Vue.use(VueSweetalert2)
Vue.use(VTooltip)

const createApp = async () => {
  await store.dispatch('auth/currentUser')
  /* eslint-disable no-new */
  new Vue({
    router,
    store,  //storeを読み込む
    render: h => h(App)
  }).$mount('#app')
}

createApp()